import { useTranslation } from "react-i18next";
import IndieStaticSelect from "./IndieStaticSelect";

export const IndieClientTypesSelect = ({ ...params }) => {

    const { t } = useTranslation();

    const selectOptions = [
        { value: "consumer", label: t("consumer") },
        { value: "producer", label: t("producer") },
        { value: "egac", label: t("egac") },
    ]
    
    return (
        <IndieStaticSelect
            {...params}
            options={selectOptions}
            label={t("clientDetails.clientTypes")}
            multiple
            sx={{ width:300 }}
        />
    );
};
